/**
 * @author Sai Prasad
 * @class SuiteFaqs
 */
    
import React, {  useEffect } from 'react';
import { selectFaqs } from '../../store/selectors/faqsNotesDocuments';
import Faqs from '../../components/Faqs';
import { setSearch, clearSearch } from '../../store/actions/search';
import Loader from '../../components/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { onFetchSuiteFaqs } from '../../store/actions/suites';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import { upload } from '../../helpers/upLoadHelper';
import { updateFaqsNotesDocuments, saveFaqsNotesDocuments, deleteFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { startFormLoading } from '../../store/actions/loader';
import { clearFndFormData } from '../../store/actions/fndForm';

const SuiteFaqs = ({
    suite
}) => {
    const dispatch = useDispatch();
    const faqs = useSelector(state => selectFaqs(state))
    const loader = useSelector(state => selectPRLoader(state));
    const user = useSelector(state => selectAuthenticatedUser(state));

    useEffect(() => {        
        dispatch(onFetchSuiteFaqs(suite.id));
        dispatch(clearSearch());
        dispatch(clearFndFormData())
    }, [])
    /*
        Created By: Sai Prasad
        Created Date: 09/09/2022
        Jira Ticket: JUN-3175
        Description: function to save or update FAQ
    */
    const onSaveFaq = async (faq) => {
      let image=null
      if(faq.uploadType==="Image"&& faq.image && faq.image.length > 0){
        dispatch(startFormLoading())
        image =  await upload(faq.image[0])
        faq = faq = {...faq,image}
      }
      

      // image = faq.image
      // faq = faq ={...faq , image}
        // delete faq.selectedImage;
        faq = {...faq, question: faq.question.trim()}
      // Modified by: Tarkeshwar Prasad Yadav
      // Modified on: 18/10/2022
      // Jira ticket: JUN-3315
      // Comment: we made category as optional.
      if(faq && faq.issue) {
        faq = {...faq, issue: faq.issue.trim()}
      }
        if(faq && faq.linkTitle) {
          faq = {...faq, linkTitle: faq.linkTitle.trim()}
        }
        if(faq && faq.caption) {
          faq = {...faq, caption: faq.caption.trim()}
        }
        let params = {
          ItemId: suite.id,
          Name: 'Frequently Asked Questions',
          Type: 'FAQS',
          data: JSON.stringify(faq).toString(),
          UserId: user.id,
          Role: user.roles[0].role.name
        }
      if(faq.id){
         params = {...params, id: faq.id}
         dispatch(updateFaqsNotesDocuments(params, "Suite"));
      }else{
         dispatch(saveFaqsNotesDocuments(params, "Suite"));
      }  
    }
     /*
        Created By: Sai Prasad
        Created Date: 09/09/2022
        Jira Ticket: JUN-3175
        Description: function to delete FAQ
    */
    const onDeleteFaqsNotesDocuments = (faq) => {
      faq = {...faq,Type:'FAQS'};
      let extraInfo = {
        type: "Suite",
        role: user.roles[0].role.name,
        suiteId: suite.id
      }
      dispatch(deleteFaqsNotesDocuments(faq, extraInfo))
    }

    return (
      loader ? <Loader /> :
      <Faqs
        faqs={faqs}
        onSearch={e => dispatch(setSearch({ faqs: e.target.value.trim() }))}
        onSaveFaq={onSaveFaq}
        onDeleteFaq={onDeleteFaqsNotesDocuments}
        hideActions={true}
      />
    );
}

export default SuiteFaqs;